import { sha256 } from 'js-sha256'
import { useEffect } from 'react'
import { useRouter } from "next/router";
import { encryptAES } from '@helper/util/useEncrypt'
import Link from 'pages/link';

type CommunityType = {
  communityId :string;
  nationCode :number;
}
type PropsType = {
  community : CommunityType
}

// const nationCode = process.env.NEXT_PUBLIC_NATION_CODE;
const API_KEY_USERNAME = 'mobile'
const API_KEY_PASSWORD = 'a4786851f5261822f0f57182ee2dc656b57687c8a105c1b697c280ef48aee7e8'

if (typeof window !== "undefined") {
  var check_url = window.location.origin;
  var check_url_query = window.location.pathname;
  var get_nation_code = check_url_query.split("/");
  var nation_code = get_nation_code[3]
  
  // if(check_url === "https://dev.sellon.net") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://staging-id-cms.sellon.net/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://dev2-cms-sgmaster.sellon.net/';
  //   }
  // } else if(check_url === "https://dev.sellon.store") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://staging-id-cms.sellon.store/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://dev2-cms-sgmaster.sellon.store/';
  //   }
  // } else if(check_url === "https://sellon.net") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://cms-idmaster.sellon.net/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://cms-sgmaster.sellon.net/';
  //   }
  // } else if(check_url === "https://sellon.store") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://cms-idmaster.sellon.store/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://cms-sgmaster.sellon.store/';
  //   }
  // }
  if(check_url === "https://dev.sellon.net") {
      var cms_url_id = 'https://staging-id-cms.sellon.net/';
      var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
  } else if(check_url === "https://dev.sellon.store") {
      var cms_url_id = 'https://staging-id-cms.sellon.store/';
      var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.store/';
  } else if(check_url === "https://sellon.net") {
      var cms_url_id = 'https://cms-idmaster.sellon.net/';
      var cms_url_sg = 'https://cms-sgmaster.sellon.net/';
  } else if(check_url === "https://sellon.store") {
    var cms_url_id = 'https://cms-idmaster.sellon.store/';
    var cms_url_sg = 'https://cms-sgmaster.sellon.store/';
  } else { // because localhost
    var cms_url_id = 'https://staging-id-cms.sellon.net/';
    var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
  }
}

export default function Redirect ({ buserid, community, nationCode, communityId }) {

  // for ios
  var router = useRouter();
  // var sellon = "https://sellon.net";
  var sellon = check_url;
  var globalroute = sellon + router.asPath
  // var globalroute = window.location.href
  var withoutsellon = router.asPath
  // console.log(withoutsellon)
  // console.log(nation_code)
  // console.log(globalroute)
  // console.log(check_url)

  const splitUrl =  globalroute.split("/");
  const referral_code = splitUrl[4];

  const isIphone = (/iphone|ipod/).test(navigator.userAgent.toLowerCase())
  const isAndroid = (/android/).test(navigator.userAgent.toLowerCase())
  
  const detectDevice = () => {
    // const isIphone = (/iphone|ipod/).test(navigator.userAgent.toLowerCase())
    // const isAndroid = (/android/).test(navigator.userAgent.toLowerCase())
    
    // var isMobile = (/iphone|ipod|android|ie|blackberry|fennec/).test(navigator.userAgent.toLowerCase());
    if (!isIphone) {
      // window.location = 'https://apps.apple.com/id/app/sellon-online-marketplace/id1462394563'
      // redirectTo()
      // console.log("ab")
      // console.log(globalroute)
        window.location = 'https://play.google.com/store/apps/details?id=com.csi.sellon'
    } else {
        window.location = 'https://apps.apple.com/id/app/sellon-online-marketplace/id1462394563'
    }
    // window.location = `http://localhost:3000/${nationCode==='62'?"id":"en-SG"}/buyandsell/${product.id}`;
  }


  useEffect(() => {

    detectDevice()

    return () => {
    }
  }, [])
    return(
      <div className="w-screen h-screen flex items-center justify-center">Content will be redirected into SellOn Apps!</div>
    )
  
}

// export async function getRedirect (community) {

//   const { nationCode , communityId } = community;

//   if (typeof window !== "undefined") {
//     var check_url = window.location.origin;
//     var check_url_query = window.location.pathname;
//     var get_nation_code = check_url_query.split("/");
//     var nation_code = get_nation_code[3]
    
//     // if(check_url === "https://dev.sellon.net") {
//     //   if(nation_code === "62") {
//     //     var cms_url = 'https://staging-id-cms.sellon.net/';
//     //   } else if(nation_code === "65") {
//     //     var cms_url = 'https://dev2-cms-sgmaster.sellon.net/';
//     //   }
//     // } else if(check_url === "https://dev.sellon.store") {
//     //   if(nation_code === "62") {
//     //     var cms_url = 'https://staging-id-cms.sellon.store/';
//     //   } else if(nation_code === "65") {
//     //     var cms_url = 'https://dev2-cms-sgmaster.sellon.store/';
//     //   }
//     // } else if(check_url === "https://sellon.net") {
//     //   if(nation_code === "62") {
//     //     var cms_url = 'https://cms-idmaster.sellon.net/';
//     //   } else if(nation_code === "65") {
//     //     var cms_url = 'https://cms-sgmaster.sellon.net/';
//     //   }
//     // } else if(check_url === "https://sellon.store") {
//     //   if(nation_code === "62") {
//     //     var cms_url = 'https://cms-idmaster.sellon.store/';
//     //   } else if(nation_code === "65") {
//     //     var cms_url = 'https://cms-sgmaster.sellon.store/';
//     //   }
//     // }
//     if(check_url === "https://dev.sellon.net") {
//         var cms_url_id = 'https://staging-id-cms.sellon.net/';
//         var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
//     } else if(check_url === "https://dev.sellon.store") {
//         var cms_url_id = 'https://staging-id-cms.sellon.store/';
//         var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.store/';
//     } else if(check_url === "https://sellon.net") {
//         var cms_url_id = 'https://cms-idmaster.sellon.net/';
//         var cms_url_sg = 'https://cms-sgmaster.sellon.net/';
//     } else if(check_url === "https://sellon.store") {
//       var cms_url_id = 'https://cms-idmaster.sellon.store/';
//       var cms_url_sg = 'https://cms-sgmaster.sellon.store/';
//     } else { // because localhost
//       var cms_url_id = 'https://staging-id-cms.sellon.net/';
//       var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
//     }
//   }

//   // const apiUrl = `${process.env.NEXT_PUBLIC_CMS_URL}api_mobile/apikey/auth/?nation_code=${nationCode}`
//   const apiUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/apikey/auth/?nation_code=${nationCode}`
//   // const apiUrl = `${nationCode==='65' ? cms_url_sg : cms_url_id}api_mobile/apikey/auth/?nation_code=${nationCode}`
//   const details = {
//     username: API_KEY_USERNAME,
//     password: API_KEY_PASSWORD
//   }
//   let formBody = []
//   for (const property in details) {
//     const encodedKey = encodeURIComponent(property)
//     const encodedValue = encodeURIComponent(details[property])
//     formBody.push(encodedKey + '=' + encodedValue)
//   }
//   formBody = formBody.join('&')

//   const apikey = await fetch(apiUrl, {
//     body: formBody,
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     },
//     method: 'POST'
//   }).then(response => response.json())
//   const { apikey_plain } = apikey.data
//   const communityUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/community/detail/${communityId}/?apikey=${sha256(apikey_plain)}&nation_code=${nationCode}`
//   // const communityUrl = `${nationCode==='65' ? cms_url_sg : cms_url_id}api_mobile/community/detail/${communityId}/?apikey=${sha256(apikey_plain)}&nation_code=${nationCode}`
//   const communityData = await fetch(communityUrl).then(response => response.json())
//   return communityData.data.community
// }

// export async function getServerSideProps ({ params }) {
//   const { nationCode, communityId } = params
//   // var { new_cms_url_id, new_cms_url_sg} = params
//   const community = await getCommunityDetail({communityId, nationCode})

//   // if (typeof window !== "undefined") {
//   //   var check_url = window.location.origin;
//   //   var check_url_query = window.location.pathname;
//   //   var get_nation_code = check_url_query.split("/");
//   //   var nation_code = get_nation_code[3]
    
//   //   if(check_url === "https://dev.sellon.net") {
//   //     new_cms_url_id = 'https://staging-id-cms.sellon.net/';
//   //     new_cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
//   //   } else if(check_url === "https://dev.sellon.store") {
//   //     new_cms_url_id = 'https://staging-id-cms.sellon.store/';
//   //     new_cms_url_sg = 'https://dev2-cms-sgmaster.sellon.store/';
//   //   } else if(check_url === "https://sellon.net") {
//   //     new_cms_url_id = 'https://cms-idmaster.sellon.net/';
//   //     new_cms_url_sg = 'https://cms-sgmaster.sellon.net/';
//   //   } else if(check_url === "https://sellon.store") {
//   //     new_cms_url_id = 'https://cms-idmaster.sellon.store/';
//   //     new_cms_url_sg = 'https://cms-sgmaster.sellon.store/';
//   //   } else { // because localhost
//   //     new_cms_url_id = 'https://staging-id-cms.sellon.net/';
//   //     new_cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
//   //   }
//   // }
//   return {
//     props: {
//       community,
//       nationCode,
//       communityId,
//       // new_cms_url_id,
//       // new_cms_url_sg,
//     }
//   }
// }